import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Signal } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { select, Store } from '@ngxs/store';
import { AutocompleteModule } from '@sag-ui';
import { LoadManagerUsers } from '../../../user-management/state/user-management.action';
import { IUser } from '@cod-monorepo/interfaces';
import { UserState } from '../../../user-management/state/user-management.state';

@Component({
    selector: 'app-manager-select',
    templateUrl: './manager-select.component.html',
    imports: [CommonModule, AutocompleteModule, ReactiveFormsModule, FormsModule],
    standalone: true
})
export class ManagerSelectComponent implements OnInit {
    @Input({ required: true }) controlName: string;
    @Input({ required: true }) formGroup: FormGroup;

    public users: Signal<IUser[]> = select(UserState.managers);
    public loading: Signal<boolean> = select(UserState.managersLoading);

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.initManagerUsers();
    }

    private initManagerUsers(): void {
        this.store.dispatch(new LoadManagerUsers());
    }
}
